// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1CompaniesCreateSchema = z.object({
  client: z.object({
    name: z.coerce.string().min(1).max(255).describe("Name of the client"),
    active: z.optional(z.boolean().describe("Whether the client is active")),
    color: z.optional(z.coerce.string().min(3).max(6).regex(new RegExp("^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$")).describe("Client display color (hex code)")),
    external_references: z.optional(z.array(z.object({
      id: z.number().int(),
      provider_type: z.coerce.string(),
      provider_id: z.coerce.string(),
      updated_at: z.string().datetime(),
      connection_id: z.number().int(),
      url: z.coerce.string().url(),
    })).describe("External references for the client")),
  }),
});
